<template>
  <div id="echarts-evento-sazonalidade" style="width: 100%; height: 100%;"></div>
</template>

<script>
import { nextTick } from "vue";
import * as echarts from 'echarts';
import { opcoes } from './Opcoes';

let myChart;

export default {
  props: {
    dados: {
      required: true,
      type: Object
    }
  },
  mounted() {
    const chartDom = document.getElementById('echarts-evento-sazonalidade');

    myChart = echarts.init(chartDom);

    async () => {
      await nextTick();
      myChart.resize();
    }

    this.redimencionarGraficoSempreQueTamanhoTelaMudar();
  },
  watch: {
    dados() {
      this.atualizarDadosGrafico();
      myChart.resize();
    },
  },
  methods: {
    redimencionarGraficoSempreQueTamanhoTelaMudar() {
      window.addEventListener('resize', function() {
        myChart.resize();
      });
    },
    atualizarDadosGrafico() {
      let date = this.dados.data_referencia;

      const opt = {
        ...opcoes,
        xAxis: {
          ...opcoes.xAxis,
          data: date
        },
        dataZoom: [
          {
            type:'inside',
            start: 0,
            end: 100,
          },
          ...opcoes.dataZoom
        ],
        series: [
          {
            name: 'Estoque',
            type: 'line',
            smooth: 0.6,
            symbol: 'none',
            data: this.dados.estoque,
          },
          {
            name: 'Saida',
            type: 'bar',
            barWidth: 10,
            data: this.dados.saida,
          },
          {
            name: 'Entradas',
            type: 'bar',
            barWidth: 10,
            data: this.dados.entrada,
          },
          {
            name: 'Estoque Segurança',
            type: 'line',
            smooth: 0.6,
            symbol: 'none',
            data: this.dados.estoque_seguranca,
          },
          {
            name: 'Ponto de Pedido',
            type: 'line',
            smooth: 0.6,
            symbol: 'none',
            data: this.dados.ponto_pedido,
          },
          {
            name: 'Estoque Maximo',
            type: 'line',
            smooth: 0.6,
            symbol: 'none',
            data: this.dados.estoque_maximo,
          },
          {
            name: 'Projeção de Venda',
            type: 'line',
            smooth: 0.6,
            symbol: 'none',
            data: this.dados.projecao_venda,
          },
        ]
      }


      myChart.setOption(opt);
      myChart.resize();

      const self = this;

      myChart.on('dataZoom', function() {
        var option = myChart.getOption();

        const data_inicial = option.xAxis[0].data[option.dataZoom[0].startValue];
        const data_final = option.xAxis[0].data[option.dataZoom[0].endValue];

        self.$emit('atualizar-detalhes', [data_inicial, data_final]);
      });
    },
  }
}
</script>

<style>

</style>
